/** Display metadata never replaces the raw column identifier. */
export function SchemaFieldLabel({
  field,
}: {
  field: { fieldName: string; label?: string | null };
}) {
  const label = field.label?.trim();
  return (
    <>
      <span className="text-xs font-medium">{label || field.fieldName}</span>
      {label && label !== field.fieldName && (
        <span className="font-mono text-xs text-muted-foreground">
          {field.fieldName}
        </span>
      )}
    </>
  );
}
